import { PRECHECK_RESULT_TYPE } from "./../const/media";

export interface IdentityInfo {
  display_name: string;
  identity_id: string;
  avatar_icon: {
    width: number;
    height: number;
    web_uri: string;
    url: string;
  };
}
export enum AvailableStatus {
  AVAILABLE = 0,
  NON_VALID_ACCOUNT = 1, // 不可用，原因是:无有效绑定账号，为1时既需要升级企业号也需要授权的，先去授权
  SCOPE_UNAVAILABLE = 2, // 不可用，原因是:权限不足
  PRIVATE_ACCOUNT = 3, // 不可用，原因是:隐私账号
  NON_BUSINESS_ACCOUNT = 4, // 不可用，原因是:不是企业号
}
export enum IdentityType {
  ALL = 0, // 不限制类型
  FAKE_USER = 1, // 假账号，不能投放tt video
  AUTH_CODE = 2, // 单账号授权post
  TT_USER = 3 // 非单独授权post的真实tt账号
}
export interface IdentityIntactInfo extends IdentityInfo {
  identity_type: IdentityType;
  available_status: AvailableStatus;
}
export const IdentityDescI18n = {
  tt: 'fastcreation_identity_list_tt',
  ttba: 'fastcreation_identity_list_ttba'
};
export const composeTeaProp = (val: string) => {
  return {
    'data-tea': 'adp_waplite_click',
    'data-tea-expose': 'adp_waplite_impression',
    'data-tea-fastcr-media': val
  };
};
export const TeaConfig = {
  CAMERA_TIPS: 'policy_button',
  CAMERA_UPLOAD_BTN: 'camera_roll_upload',
  LIBRARY_IMAGE_TAB: 'library_image',
  LIBRARY_VIDEO_TAB: 'library_video',
  TT_ITEM: 'tiktok_video_available_select',
  TT_AUTH_BTN: 'tiktok_video_no_account_connect',
  TT_SELECT_BTN: 'tiktok_video_no_valid_identity_select',
  TT_REFRESH: 'tiktok_video_no_video_refresh',
  TT_IDENTITY_SWITCH_ANOTHER: 'select_another_account_switch',
  TT_IDENTITY_CONNECT: 'tiktok_account_link_new_account',
  TT_IDENTITY_UPGRADE: 'select_another_account_upgrade',
  TT_IDENTITY_AUTH: 'select_another_account_authorize',
  TT_UNAVAILABLE: 'tiktok_video_not_available',
  TT_IDENTITY_SWITCH: 'tiktok_account_switch',
  CAMERA_UPLOAD_FAIL: 'camera_roll_upload_failed_try_again',
  OPTIMIZE_FAIL: 'optimization_failed_try_again',
  MEDIA_CHANGE_DIALOG: 'media_type_change_notification',
  MEDIA_CHANGE_CONFIRM: 'media_type_change_notification_confirm',
  MEDIA_CHANGE_CANCEL: 'media_type_change_notification_cancel',
  MEDIA_NEXT: 'media_next',
  MEDIA_BACK: 'media_back',
  AUDIT_TAGS: {
    [PRECHECK_RESULT_TYPE.VIDEO_DURATION]: 'upload1_upload_evaluate_new_suggestion21000060',
    [PRECHECK_RESULT_TYPE.VIDEO_BLACK_BORDER]: 'upload1_upload_evaluate_new_suggestion50030005',
    [PRECHECK_RESULT_TYPE.VIDEO_MUTE]: 'upload1_upload_evaluate_new_suggestion50030003',
    [PRECHECK_RESULT_TYPE.IMAGE_CONTENT]: 'upload1_upload_evaluate_new_suggestion15011',
    [PRECHECK_RESULT_TYPE.VIDEO_LOGO]: 'upload1_upload_evaluate_new_suggestion20100172',
    [PRECHECK_RESULT_TYPE.VIDEO_MOSAIC]: 'upload1_upload_evaluate_new_suggestion21500006'
  },
  // 以下是param
  CAMERA_ROLL: {
    IMAGE_AUDIT: 'fastcr_video_duration_camera_image_preaudit',
    VIDEO_AUDIT: 'fastcr_video_duration_camera_video_preaudit',
    IMAGE_OPTIMIZE: 'fastcr_video_duration_camera_image_composing',
    VIDEO_OPTIMIZE: 'fastcr_video_duration_camera_video_composing',
    IMAGE_UPLOAD: 'fastcr_video_duration_camera_image_upload',
    VIDEO_UPLOAD: 'fastcr_video_duration_camera_video_upload'
  },
  LIBRARY: {
    IMAGE_OPTIMIZE: 'fastcr_image_creative_duration_library',
    VIDEO_OPTIMIZE: 'fastcr_video_creative_duration_library'
  },
  TTBA_UPGRADE: {
    SUCCESS: 'ttba_upgrade_success',
    FAILED: 'ttba_upgrade_failed'
  },
  TT_ANOTHER_AUTH: {
    SUCCESS: 'tt_another_authorize_success',
    FAILED: 'tt_another_authorize_failed'
  },
  TT_AUTH: {
    SUCCESS: 'tt_noaccount_authorize_success',
    FAILED: 'tt_noaccount_authorize_failed'
  }
};
export const IdentityDefaultAvatar = require('@/assets/images/tiktok-avatar.svg');

